module.exports = __webpack_public_path__ + "img/icon-metro-1.9bc50293.png";